<template>
  <q-page class="flex column home page-layout">
    <div class="grid-container-1-column--centered">
      <section class="grid-container-1-column__item">
        <q-card flat class="form-card" style="width: 100%; max-width: 500px">
          <q-card-section class="form-card__section">
            <CreateUser formType="Partner_Admin" /> </q-card-section
        ></q-card>
      </section>
    </div>
  </q-page>
</template>

<script>
import CreateUser from "@/components/forms/CreateUser.vue";
export default {
  name: "CreateUserView",
  components: {
    CreateUser,
  },
};
</script>
